import client from './client';
import { unwrapData } from './response';

export const listCustomers = async (params = {}) => {
  const response = await client.get('/customers', { params });
  return unwrapData(response);
};

export const getCustomer = async (id) => {
  const response = await client.get(`/customers/${id}`);
  return unwrapData(response, null);
};

export const createCustomer = async (payload) => {
  const response = await client.post('/customers', payload);
  return unwrapData(response, null);
};

export const updateCustomer = async (id, payload) => {
  const response = await client.put(`/customers/${id}`, payload);
  return unwrapData(response, null);
};

export const deleteCustomer = async (id) => {
  const response = await client.delete(`/customers/${id}`);
  return unwrapData(response, null);
};
